import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.array.sort";
import _toConsumableArray from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as Data from "@/data";
export default {
  props: {
    value: {
      default: null
    },
    readOnly: {
      default: true
    },
    label: {
      type: String
    },
    optionLabel: {
      default: "NotSet"
    },
    optionValue: {
      default: "NotSet"
    },
    entity: {
      default: "NotSet"
    },
    multiple: {
      default: false
    },
    filter: {},
    clearable: {
      default: true
    },
    disable: {
      default: false
    },
    required: {
      default: false
    },
    compressSelectedOptions: {
      default: false,
      type: Boolean
    },
    optionsSelectedClass: {
      type: String
    }
  },
  data: function data() {
    return {
      options: []
    };
  },
  created: function created() {
    this.loadOptions();
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;

      var list = _toConsumableArray(this.options);

      if (this.filter) list = this.filter(list, this.value);

      if (this.optionLabel != "NotSet") {
        list = list.filter(function (x) {
          return x[_this.optionLabel] != null || _this.optionValue != "NotSet" && x[_this.optionValue] == _this.value;
        });
        list = list.sort(function (a, b) {
          return a[_this.optionLabel] > b[_this.optionLabel] || a[_this.optionLabel] == null ? 1 : -1;
        });
      }

      return list;
    }
  },
  methods: {
    loadOptions: function () {
      var _loadOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Data[this.entity].GetAll();

              case 2:
                this.options = _context.sent.data;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadOptions() {
        return _loadOptions.apply(this, arguments);
      }

      return loadOptions;
    }()
  },
  watch: {
    entity: function entity() {
      this.loadOptions();
    }
  }
};